import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import ListReferralPolicies from './submodules/list';
import UpdateUserSegment from './submodules/addUser';

const UpdateUserReferralSegmentDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.referral}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.referral].getReferralSegmentPolicies]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListReferralPolicies}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.referral}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.referral].updateUserReferralSegment]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/updateUserReferralSegment`}
				component={UpdateUserSegment}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default UpdateUserReferralSegmentDashboard;
